import { render } from "./LeaseAndResident.vue?vue&type=template&id=8106c9a0&scoped=true"
import script from "./LeaseAndResident.vue?vue&type=script&lang=js"
export * from "./LeaseAndResident.vue?vue&type=script&lang=js"

import "./LeaseAndResident.vue?vue&type=style&index=0&id=8106c9a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8106c9a0"]])

export default __exports__